<div *ngIf="visible" class="flex flex-column items-end jumbotron mb-6 p-6">
    <div *ngIf="closable">
        <button mat-icon-button (click)="close()">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <div class="flex justify-content-arround gap-[48px] px-6 pb-6">
        <div *ngIf="imageSrc" class="flex justify-center items-center">
            <img class="image" [src]="imageSrc" />
        </div>
        <div class="flex flex-column gap-4">
            <h3 *ngIf="title" class="ca-headline-3 mb-0">{{ title }}</h3>
            <div class="content"><ng-content></ng-content></div>
        </div>
    </div>
</div>
